import {
  ChartIcon,
  CameraIcon,
  VideoIcon,
  MapIcon,
  HomeIcon,
  CPUIcon,
  PeoplesIcon,
  TicketIcon,
} from "../../../components/Icons/Icons";
import CarIcon from "../../../components/Icons/SideBar/CarIcon";
import { FaceDetectionIcon } from "../../../components/Icons/SideBar/FaceDetection";
import { NotificationIcon } from "../../../components/Icons/SideBar/NotificationIcon";
import i18n from "../../../i18n";
const { t } = i18n
export const nav = [
  {
    // activeIcon: <HomeIconActive />,
    icon: <HomeIcon />,
    title: t("sideBar.home"),
    to: "/",
    target: ""
  },
  {
    // activeIcon: <CameraActiveIcon />,
    icon: <CameraIcon />,
    title: t("sideBar.live"),
    to: "/live-camera",
    target: ""
  },
  {
    // activeIcon: <MapActiveIcon />,
    icon: <MapIcon />,
    title: t("sideBar.map"),
    to: "/map",
    target: ""
  },
  {
    // activeIcon: <VideoActiveIcon />,
    icon: <VideoIcon />,
    title: t("sideBar.playback"),
    to: "/playback-video",
    target: ""
  },
  {
    // activeIcon: <VideoActiveIcon />,
    icon: <PeoplesIcon />,
    title: t("sideBar.manage"),
    to: `${process.env.REACT_APP_BASE_URL}admin/camera?openKey=sub5&key=10`,
    target: "_blank"
  },
  {
    // activeIcon: <ChartActive />,
    icon: <ChartIcon />,
    title: t("sideBar.dashboard"),
    to: "/dashboard",
    target: ""
  },
  {
    icon: <TicketIcon />,
    title: t("sideBar.ticketManagement"),
    to: "/ticket-management",
    target: ""
  },
];
export const subMenu = [
  {
    title: 'Camera',
    to: '/admin/camera',
    role: "C",
  },
  {
    title: 'Quyền camera',
    to: '/admin/camera_role',
    role: "C",

  },
  {
    title: 'Công ty',
    to: '/admin/companies',
    role: "U",

  },
  {
    title: 'Kho',
    to: '/admin/warehouse',
    role: "C",

  },
  {
    title: 'Nhóm camera',
    to: '/admin/camera_group',
    role: "C",

  },
  {
    title: 'Người dùng',
    to: '/admin/user',
    role: "U",

  },
  {
    title: 'Quyền người dùng',
    to: '/admin/role',
    role: "R",
  },
  {
    title: 'Thiết lập mặc định',
    to: '/admin/set-default',
    role: "C",
  },
  {
    title: 'Dịch vụ',
    to: '/admin/service',
    role: "C",

  },
  // {
  //   title: 'Thông báo',
  //   to: '/admin/notification',
  //   role: "N",

  // },
]

export const subHistory = [
  {
    title: 'Lịch sử truy cập',
    to: '/history/access',
    role: "",
  },
  {
    title: 'Lịch sử người dùng',
    to: '/history/user'
  },
  // {
  //   title: 'Lịch sử xem trực tiếp',
  //   to: '/history/live'
  // },
  // {
  //   title: 'Lịch sử xem lại',
  //   to: '/history/playback'
  // },
  {
    title: 'Lịch sử cấu hình',
    to: '/history/configuration'
  },
  // {
  //   title: 'Lịch sử thiết bị',
  //   to: '/history/equipment'
  // },
  {
    title: 'Lịch sử lỗi',
    to: '/history/error'
  },
]

export const subManagerAI = [
  {
    title: 'Truy vết sự kiện',
    to: '/manager-ai/event-tracing'
  },
  {
    title: 'Chấm công',
    to: '/manager-ai/timekeeping'
  },
  {
    title: 'Đối soát camera',
    to: '/manager-ai/camera-control'
  },
]
export const subSec = [
  {
    title: 'Camera',
    to: '/admin/camera'
  },
  {
    title: 'Nhóm camera',
    to: '/admin/camera_group'
  },
]

export const subLisencePlate = [
  {
    title: 'Xem video',
    to: '/lisence-plate/view-video'
  },
  {
    title: 'Quản trị dịch vụ',
    to: '/lisence-plate/manager'
  }
]
export const subFaceDetection = [
  {
    title: 'Xem video',
    to: '/face-detection/view-video'
  },
  {
    title: 'Quản trị dịch vụ',
    to: '/face-detection/manager'
  }
]
export const subFireAlarm = [
  {
    title: 'Xem video',
    to: '/fire-alarm/view-video'
  },
  {
    title: 'Quản trị dịch vụ',
    to: '/fire-alarm/manager'
  }
]